import React from 'react'
import { ComposableMap, Geographies, Geography } from 'react-simple-maps'
import { scaleLinear } from 'd3'
import { Tooltip } from 'react-tooltip'
import { useStyles } from './CountriesMap.styles'
import { MetricsData } from '../../../modules/storefrontMetrics/reducer'
import { useSelector } from '../../../store'

export default function CountriesMap() {
  const { classes } = useStyles()
  const { mapData } = useSelector<MetricsData>(
    state => state.storefrontMetricsData
  )
  const maxImpression =
    mapData && Object.keys(mapData).length > 0
      ? Math.max(
          ...Object.values(mapData).map((x: any) => x.currentImpressions)
        ) || 0
      : 0
  const scale = getScale(maxImpression)
  return (
    <div className={classes.root} data-testid="map-section">
      <div className={classes.mapWrapper}>
        <div className={classes.map}>
          <ComposableMap
            projection="geoMercator"
            projectionConfig={{
              parallels: [0, 0],
              center: [0, 0],
              scale: 100,
            }}
            viewBox="0 0 800 425"
            style={{ width: '100%', height: 'auto' }}
          >
            <Geographies geography="https://assets.flyout.labra.io/topojson/map.json">
              {({ geographies }) =>
                geographies.map(geo => {
                  let currentImpressions = 0
                  if (mapData[geo.id]) {
                    currentImpressions = mapData[geo.id]
                      ? mapData[geo.id]['currentImpressions']
                      : 0
                  }
                  return (
                    <Geography
                      data-tooltip-id="map-tooltip"
                      data-tooltip-html={`<div> ${geo.properties.name}: ${currentImpressions} </div>`}
                      key={geo.rsmKey}
                      geography={geo}
                      fill={
                        mapData[geo.id]
                          ? String(scale(mapData[geo.id]['currentImpressions']))
                          : '#e3e3e3'
                      }
                      style={{
                        hover: {
                          fill: '#F53',
                          outline: 'none',
                        },
                        pressed: {
                          fill: '#E42',
                          outline: 'none',
                        },
                      }}
                    />
                  )
                })
              }
            </Geographies>
          </ComposableMap>
          <Tooltip id="map-tooltip" />
        </div>

        <div className={classes.wrapperGradient}>
          <div className={classes.verticalGradientBar}>
            <div className={classes.gradient} />
            <div className={classes.labelTop}>{maxImpression}</div>
            <div className={classes.labelBottom}>0</div>
          </div>
        </div>
      </div>
    </div>
  )
}

const getScale = (maxImpression: number) => {
  // @ts-expect-error (https://d3js.org/d3-scale/sequential#sequential_range)
  return scaleLinear().domain([0, maxImpression]).range(['#e3e3e3', '#007d38'])
}
